import { render, staticRenderFns } from "./lsCollFromRegList.vue?vue&type=template&id=1af64ae6&scoped=true&"
import script from "./lsCollFromRegList.vue?vue&type=script&lang=js&"
export * from "./lsCollFromRegList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af64ae6",
  null
  
)

export default component.exports